import React from 'react'

import './timestamps.scss'
import CreatedIcon from './icons/created-icon'
import UpdatedIcon from './icons/updated-icon'
import {formatTimestampToDate} from '../utils/format-timestamp'
import {useObject} from './object-store'



export default function Timestamps({object}) {
    return <div className="timestamps">
        <div title="updated" className="timestamps__row"><UpdatedIcon color="white" /> {formatTimestampToDate(object._updated_at)}</div>
        <div title="created" className="timestamps__row"><CreatedIcon color="white" /> {formatTimestampToDate(object._created_at)}</div>
    </div>
}


export function ObjectTimestamps({id}) {
    const object = useObject(id)
    return <Timestamps object={object} />
}
